import api from './api';

export const productService = {
  // Get all products (admin view)
  getAllProducts: async (params = {}) => {
    const response = await api.get('/admin/products', { params });
    return response.data.data;
  },

  // Get product by ID
  getProductById: async (productId) => {
    const response = await api.get(`/admin/products/${productId}`);
    return response.data.data.product;
  },

  // Create product (supports both FormData and regular JSON)
  createProduct: async (productData) => {
    // Check if it's FormData (for file uploads)
    const isFormData = productData instanceof FormData;
    
    const config = {
      headers: isFormData
        ? {
            // Don't set Content-Type for FormData - let browser set it with boundary
          }
        : {
            'Content-Type': 'application/json',
          },
    };

    const response = await api.post('/admin/products', productData, config);
    return response.data.data;
  },

  // Update product (supports both FormData and regular JSON)
  updateProduct: async (productId, productData) => {
    // Check if it's FormData (for file uploads)
    const isFormData = productData instanceof FormData;
    
    const config = {
      headers: isFormData
        ? {
            // Don't set Content-Type for FormData - let browser set it with boundary
          }
        : {
            'Content-Type': 'application/json',
          },
    };

    const response = await api.put(`/admin/products/${productId}`, productData, config);
    return response.data.data;
  },

  // Delete product
  deleteProduct: async (productId) => {
    const response = await api.delete(`/admin/products/${productId}`);
    return response.data;
  },
};
